import React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ExpandMore } from '@mui/icons-material';
import {
  data as dSubStatusRecouvrement,
} from '@lba-dev/package.local-globals/dSubStatusRecouvrement';

const SubStatusDevis = React.memo(({ value, handleChange }) => (
  dSubStatusRecouvrement.map((e) => {
    const element = e.values.find((s) => s._id === value);
    return (
      <Grid item xs={4} key={`${e.type}-${value}`}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Grid container spacing={2}>
              <Grid item xs={9}>
                <Typography>{e.type}</Typography>
              </Grid>
              {element && (
                <Grid item xs={3}>
                  <Typography variant="caption">
                    {element.shortName?.toUpperCase()}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails>
            <RadioGroup value={value ? value : ''} onChange={handleChange}>
              <Grid container justifyContent="center">
                {e.values.map((value) => (
                  <Grid item xs={6} key={`${value.name}`}>
                    <FormControlLabel
                      value={value._id}
                      control={<Radio />}
                      label={value.shortName}
                    />
                  </Grid>
                ))}
              </Grid>
            </RadioGroup>
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  })
));

export default (SubStatusDevis);
